import type { Editor } from "@repo/fika-blog/src/tiptap/core"

export function resize(file: File): Promise<any> {
  const maxWidth = 1200
  const maxHeight = 1200
  const quality = 0.8
  const image = new Image()
  const url = URL.createObjectURL(file)

  return new Promise((resolve, reject) => {
    image.onload = () => {
      const canvas = document.createElement("canvas")
      const ctx = canvas.getContext("2d")

      if (!ctx) return reject("Error")

      let width = image.width
      let height = image.height

      if (width > height) {
        if (width > maxWidth) {
          height *= maxWidth / width
          width = maxWidth
        }
      } else {
        if (height > maxHeight) {
          width *= maxHeight / height
          height = maxHeight
        }
      }

      canvas.width = width
      canvas.height = height

      ctx.drawImage(image, 0, 0, width, height)

      const dataURL = canvas.toDataURL("image/webp", quality)
      resolve(dataURL)
    }
    image.src = url
  })
}

export function onDrop(currentEditor: Editor, files: File[], pos: number) {
  for (const file of files) {
    resize(file).then(src => {
      currentEditor
        .chain()
        .insertContentAt(pos, {
          type: "image",
          attrs: { src },
        })
        .focus()
        .run()
    })
  }
}

export function onPaste(
  currentEditor: Editor,
  files: File[],
  htmlContent: string | undefined,
) {
  for (const file of files) {
    if (htmlContent) {
      return false
    }

    resize(file).then(src => {
      currentEditor
        .chain()
        .insertContentAt(currentEditor.state.selection.anchor, {
          type: "image",
          attrs: { src },
        })
        .focus()
        .run()
    })
  }
}
